export const TGS_STRATEGIES = {
    burst: (p, speed) => {
        const angle = Math.random() * Math.PI * 2;
        const force = (Math.random() * 2 + 5) * (speed / 5);
        p.vx = Math.cos(angle) * force;
        p.vy = Math.sin(angle) * force;
        // p.gravity = 0.1;
        p.gravity = 0.2;
        p.rotationSpeed = (Math.random() - 0.5) * 0.2;
        p.useOpacity = true;
    },
    rain: (p, speed) => {
        p.x = Math.random() * window.innerWidth;
        p.y = -50;
        p.vx = (Math.random() - 0.5) * 2;
        p.vy = (Math.random() * 3 + 2) * (speed / 5);
        p.gravity = 0.05;
        p.rotationSpeed = (Math.random() - 0.5) * 0.1;
    },
    fountain: (p, speed) => {
        p.vx = (Math.random() - 0.5) * 4;
        p.vy = (Math.random() * -12 - 5) * (speed / 5);
        p.gravity = 0.3;
        p.rotationSpeed = (Math.random() - 0.5) * 0.15;
    },
    float: (p, speed) => {
        p.vx = (Math.random() - 0.5) * 1.5;
        p.vy = (Math.random() * -1 - 0.5) * (speed / 5);
        p.gravity = -0.01; // Легкая антигравитация
        p.rotationSpeed = (Math.random() - 0.5) * 0.05;
        p.useOscillation = true; // Будет покачиваться влево-вправо
    },
    glass: (p, speed) => {
        p.isGlass = true;
        p.status = 'flying'; // flying -> hit -> sliding
        p.targetScale = 1;//.5 + Math.random() * 1.0; // Сильное увеличение
        p.scale = 0.1; 
        p.opacity = 0;
        
        // Точка "удара" чуть смещена от клика для разлета
        p.targetX = p.x + (Math.random() - 0.5) * 300;
        p.targetY = p.y + (Math.random() - 0.5) * 300;
        
        p.vx = (p.targetX - p.x) * 0.05;
        p.vy = (p.targetY - p.y) * 0.05;
        
        p.hitDuration = 40 + Math.random() * 20; // Сколько провисит на стекле
        p.slideSpeed = (0.5 + Math.random() * 1) * (speed / 5);
    }
};

export const TGS_DEFAULT_LIKE = [
    {
        collection: 'SmileysAndEmotions',
        code: 'fire'
    }, {
        collection: 'SmileysAndEmotions',
        code: 'heart_on_fire_v'
    }, {
        collection: 'SmileysAndEmotions',
        code: 'star_struck'
    }, {
        collection: 'SmileysAndEmotions',
        code: 'party_popper'
    }
];
